import clsx from 'clsx'

type DigitalAssetIconProps = {
  fileName: string
  className?: string
  style?: React.CSSProperties
}

const DigitalAssetIcon: React.FC<
  React.PropsWithChildren<DigitalAssetIconProps>
> = ({ fileName, className, style = {} }) => {
  return (
    <i
      className={clsx(className, getCssIconNameForFile(fileName))}
      style={style}
    />
  )
}

export default DigitalAssetIcon

export function getCssIconNameForFile(fileName: string): string {
  const extension = fileName && fileName.split('.').pop()

  switch (extension) {
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'eps':
      return 'far fa-file-image'
    case 'doc':
    case 'docx':
      return 'far fa-file-word'

    case 'xls':
    case 'xlsx':
    case 'csv':
      return 'far fa-file-excel'

    case 'ppt':
      return 'far fa-file-powerpoint'

    case 'zip':
      return 'far fa-file-archive'
    case 'mp4':
    case 'avi':
      return 'far fa-file-video'
    case 'mp3':
    case 'aac':
    case 'wav':
    case 'ogg':
    case 'wma':
    case 'aiff':
    case 'flac':
      return 'far fa-file-audio'

    default:
      return 'far fa-file-alt'
  }
}
